import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { mediaUpdated, selectMediaById } from "./mediaSlice";

const EditMediaForm = () => {
    const { itemId } = useParams();
    const item = useSelector(state => selectMediaById(state, itemId));

    const dispatch = useDispatch();
    const navigate = useNavigate();

    if (!item) {
        return <div>
            <h2>Item not found!</h2>
        </div>
    }

    const onSaveItemClicked = (e) => {
        e.preventDefault();
        const { elements } = e.currentTarget;
        const label = elements.mediaLabel.value;
        const date = elements.mediaDate.value;
        const dateDisplay = elements.mediaDateDisplay.value;
        const year = elements.mediaYear.value;
        const type = elements.mediaType.value;
        const title = elements.mediaTitle.value;
        const url = elements.mediaUrl.value;
        const iFrame = elements.mediaIFrame.value;

        if (label && title) {
            const newMedia = {
                id: item.id, label, date, dateDisplay, year, type, title, url, iFrame
            };
            dispatch(mediaUpdated(newMedia));
            navigate(`/media/${itemId}`);
        }
    }

    return <div>
        <h2>Edit Media Entry</h2>
        <form onSubmit={onSaveItemClicked}>
            <label htmlFor="mediaLabel">Label:</label>
            <input type="text" style={{width: "700px"}} id="mediaLabel" name="mediaLabel" defaultValue={item.label} required />
            <br/>
            <label htmlFor="mediaTitle">Title:</label>
            <input type="text" style={{width: "700px"}} id="mediaTitle" name="mediaTitle" defaultValue={item.title} required />
            <br/>
            <label htmlFor="mediaDate">Date (YYYY-MM-DD):</label>
            <input type="text" id="mediaDate" name="mediaDate" defaultValue={item.date} required />
            <br/>
            <label htmlFor="mediaDateDisplay">Date Display:</label>
            <input type="text" id="mediaDateDisplay" name="mediaDateDisplay" defaultValue={item.dateDisplay} required />
            <br/>
            <label htmlFor="mediaYear">Year:</label>
            <input type="text" id="mediaYear" name="mediaYear" defaultValue={item.year} required />
            <br/>
            <label htmlFor="mediaType">Type [article,book-mention,presentation,press-release,video,other]:</label>
            <input type="text" id="mediaType" name="mediaType" defaultValue={item.type} required />
            <br/>
            <label htmlFor="mediaUrl">URL:</label>
            <input type="text" id="mediaUrl" name="mediaUrl" defaultValue={item.url} />
            <br/>
            <label htmlFor="mediaIFrame">iFrame:</label>
            <input type="text" id="mediaIFrame" name="mediaIFrame" defaultValue={item.iFrame} />
            <br/>
            <button>Save Entry</button>
        </form>
    </div>
}

export { EditMediaForm };